




























import Vue from 'vue'
import ModalFullScreen from '@/common/components/ModalFullScreen.vue'
import { ProductEditPattern } from '@/product/types'
import EditPatternOption from '@/product/components/printingOptions/EditPatternOption.vue'
import { scrollToElement } from '@/helper'

export default Vue.extend({
  components: { ModalFullScreen, EditPatternOption },
  props: {
    editPatterns: {
      type: Array as () => ProductEditPattern[],
      required: true
    },
    selectedPattern: {
      type: Object as () => ProductEditPattern,
      default: undefined
    }
  },
  data(): {
    currentPattern: ProductEditPattern
  } {
    return {
      currentPattern: this.selectedPattern
    }
  },
  created() {
    this.$nextTick(() =>
      scrollToElement('[class="pr-EditPatternOption"][aria-selected="true"]')
    )
  },
  methods: {
    updateCurrentPattern(option: ProductEditPattern) {
      this.currentPattern = option
    },
    onUpdateSelectedPattern() {
      this.$emit('update', this.currentPattern.id)
    },
    onCloseModal() {
      this.$emit('close')
    }
  }
})
